module.exports = __webpack_public_path__ + "img/capturer-diplomat-4.8ef9320d.svg";